import React from 'react';

/**
 * WyrdMaker Logo — Monogramme WM officiel + texte optionnel
 *
 * Props:
 *   variant: "auto" (adapte au thème) | "light" (blanc) | "dark" (noir)
 *   showText: true/false — affiche "Wyrd Maker" à droite
 *   size: "xs" | "sm" | "md" | "lg" | "xl"
 *   className: classes CSS additionnelles
 *   textClassName: classes CSS pour le texte uniquement
 */

const SIZES = {
  xs: { icon: 22, text: 'text-xs', gap: 'gap-1' },
  sm: { icon: 28, text: 'text-sm', gap: 'gap-1.5' },
  md: { icon: 36, text: 'text-lg', gap: 'gap-2' },
  lg: { icon: 48, text: 'text-xl', gap: 'gap-2.5' },
  xl: { icon: 64, text: 'text-2xl', gap: 'gap-3' },
};

// Official WM monogram SVG path (from the real icon files)
const WM_PATH = "M10 1637 c0 -8 8 -34 17 -58 17 -40 18 -101 18 -739 0 -631 -2 -701 -17 -758 -10 -35 -18 -67 -18 -72 0 -4 75 -7 167 -6 l166 1 91 247 c50 136 94 244 97 240 4 -4 42 -101 84 -217 113 -308 94 -276 160 -274 30 1 59 7 64 13 4 6 48 122 97 258 49 137 92 248 95 248 3 0 48 -116 100 -258 l94 -257 173 -2 c94 -2 172 1 172 6 0 5 -8 28 -17 52 -17 41 -18 101 -18 764 0 660 2 724 18 764 9 24 14 47 11 53 -3 5 -73 8 -165 7 l-160 -2 -13 -26 c-7 -14 -48 -123 -91 -241 -43 -118 -81 -218 -85 -222 -3 -4 -46 101 -95 235 -48 133 -93 245 -99 249 -6 4 -35 6 -64 5 l-55 -2 -88 -245 c-49 -135 -93 -253 -97 -263 -6 -14 -30 43 -91 210 -46 125 -90 244 -98 265 l-14 36 -170 2 c-139 1 -169 -2 -169 -13z m1283 -785 c1 -204 -1 -368 -4 -364 -3 4 -36 89 -72 190 l-67 182 68 184 c37 102 68 183 70 181 2 -2 4 -170 5 -373z m-435 154 l69 -189 -66 -178 c-36 -99 -68 -179 -71 -179 -3 0 -36 84 -73 187 l-68 187 68 183 c37 100 68 181 70 180 1 -2 33 -88 71 -191z m-504 -20 c36 -99 66 -187 66 -196 0 -15 -127 -370 -136 -379 -2 -2 -4 168 -4 379 0 211 2 381 4 379 2 -2 34 -85 70 -183z";

const WMMonogram = ({ size = 36, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size * (165 / 157)}
    viewBox="0 0 1570 1650"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g transform="translate(0,1650) scale(1,-1)" fill={color} stroke="none">
      <path d={WM_PATH} />
    </g>
  </svg>
);

export const WyrdMakerLogo = ({
  variant = 'auto',
  showText = true,
  size = 'md',
  className = '',
  textClassName = '',
}) => {
  const sizeConfig = SIZES[size] || SIZES.md;

  const colorClass =
    variant === 'light'
      ? 'text-white'
      : variant === 'dark'
        ? 'text-black'
        : 'text-foreground';

  return (
    <span className={`inline-flex items-center ${sizeConfig.gap} ${colorClass} ${className}`}>
      <WMMonogram size={sizeConfig.icon} />
      {showText && (
        <span className={`font-cinzel font-bold tracking-wide ${sizeConfig.text} ${textClassName}`}>
          WyrdMaker
        </span>
      )}
    </span>
  );
};

/**
 * Logo icon seul (pour petits espaces, Login, Register, etc.)
 */
export const WyrdMakerIcon = ({ size = 28, className = '' }) => (
  <span className={`inline-flex text-foreground ${className}`}>
    <WMMonogram size={size} />
  </span>
);

export default WyrdMakerLogo;
